import client from '../services/client';

export const getAutopassPaymentUrl = async ({
  invoiceId,
}: {
  invoiceId: string;
}) => {
  const response = await client.getAutopassPaymentUrl({
    invoiceId,
  });

  return response.data.data.payment_link;
};
